import React, { Fragment } from 'react'
import { get } from 'lodash'
import Slider from 'react-slick'
import { Col, Container, Row } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'

import Typography from 'components/atoms/Typography'
import Image from 'components/atoms/Image'

import 'slick-carousel/slick/slick.css'
import './AudioGrid.scss'

function AudioGrid({ data }) {
  const setting = {
    dots: true,
    dotsClass: 'slick-dots primary',
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  }

  function getSrcSoundCloud(rawSrc) {
    const src = rawSrc.match('/user-.+/')
    const id = src && src[0].replace(/user-|\//g, '')
    return `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/293&amp;${id}`
  }

  return (
    <div className="audio-grid py-5">
      <Container>
        <Slider {...setting}>
          {get(data, 'items').map(({ entity }) => {
            return get(entity, 'media.entity.entityBundle') === 'remote_audio' ? (
              <iframe
                key={get(data, 'uuid')}
                height="100%"
                scrolling="no"
                frameBorder="no"
                allow="autoplay"
                src={getSrcSoundCloud(get(entity, 'media.entity.fieldMediaOembedAudio'))}
                title="Audio"
              />
            ) : (
              <Row className="audio-grid__item d-flex" key={get(data, 'uuid')}>
                <>
                  {get(entity, 'thumb.entity.images') && (
                    <Col xs="12" md="3" className="fluid">
                      <Image
                        className="h-100 w-100"
                        lazyloadClassName="audio-grid__image d-flex"
                        src={get(entity, 'thumb.entity.images.medium.url')}
                        alt={get(entity, 'thumb.entity.alt')}
                      />
                    </Col>
                  )}
                  <Col xs="12" md="9" className="fluid">
                    <figure className="p-2 p-lg-3 mb-0 h-100 audio-grid__content d-flex flex-column">
                      <Typography color="gray-100">{get(entity, 'title')}</Typography>
                      <a
                        href={get(entity, 'media.entity.fieldMediaAudioFile.entity.url')}
                        download
                        target="_blank"
                        className="text-green-dark-100"
                      >
                        {ReactHtmlParser(get(entity, 'description.value'))}
                      </a>
                      <audio controls className="flex-grow-1">
                        <source src={get(entity, 'media.entity.fieldMediaAudioFile.entity.url')} type="audio/mpeg" />
                      </audio>
                    </figure>
                  </Col>
                </>
              </Row>
            )
          })}
        </Slider>
      </Container>
    </div>
  )
}

export default AudioGrid
